import React, { Component } from "react";
import Bitcoin from "../asset/images/bitcoin.jpeg"
import Ethereum from "../asset/images/etherum.jpeg"
// import TetherERC from "../asset/images/bnb.PNG"
// import TetherTRC from "../asset/images/usdt-tron.PNG"
import { Link } from "react-router-dom";
import Cryptologo from "../asset/images/crypto_link.png"


class DepositContent extends Component {
    state = {
        coin: this.props.method || "",
        selectedWallet: "",
        activeRequest: false,
        copied: false,
        currency: [
            { name: "bitcoin", walletId: "1GfUx7T5btqK5rhXab1qBkTVEGAJBkoTST", image: Bitcoin },
            { name: "ethereum", walletId: "0x012F1405191a6C1e63f1375d9fA384947d164702", image: Ethereum },
            // { name: "bnb", walletId: "0x354e6AB93cBc0c16b6f3Ce6cd7CdCD8E4db53247", image: TetherERC },
            // { name: "tether_trc", walletId: "TB7a9NCq1nZMKtDpY4LsGvhhAUj9hV16J2", image: TetherTRC }
        ]
        // currency: [
        //     { name: "bitcoin", walletId: "bc1q50ktmjnhgqx5zylmysyvcrynj2zazq8lrj3qcl", image: Bitcoin },
        //     { name: "ethereum", walletId: "0x4f504DFaAe1F354009Ff41139159Df1241e3e987", image: Ethereum },
        //     { name: "bnb", walletId: "0x4f504DFaAe1F354009Ff41139159Df1241e3e987", image: TetherERC },
        //     { name: "tether_trc", walletId: "TC1ooCaQ3have6WrNtMsgMYWvri91q5sDz", image: TetherTRC }
        // ]
    }


    handleInputChange = (event) => {
        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }
    handleRadio = (type) => {
        this.setState({ selectedWallet: type });
    };

    handleSubmit = (e) => {
        e.preventDefault()


        this.setState({
            activeRequest: true
        })
    }



    handleCopy = (textToCopy) => {

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    this.setState({ copied: true });
                    setTimeout(() => this.setState({ copied: false }), 2000); // Reset after 2s
                })
                .catch(err => {
                    console.error('Failed to copy: ', err);
                });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                this.setState({ copied: true });
                setTimeout(() => this.setState({ copied: false }), 2000);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
            document.body.removeChild(textArea);
        }
    };



    render() {
        const { method } = this.props
        const { selectedWallet, activeRequest, coin, copied } = this.state
        const { currency } = this.state;

        const selectedCurrency = currency.find(
            (item) => item.name === method
        );


        const currencyList = currency.length > 0 ? currency.map(list => {
            return (

                <div style={{ marginBottom: "20px" }} key={list.walletId}>
                    <label>Your unique {list.name} wallet address</label>
                    <p><b>{list.walletId}</b></p>
                    <div className="image">
                        <img src={list.image} alt="image1" />
                    </div>
                    <div className="button" >
                        <button className="black" onClick={() => { this.handleCopy(list.walletId) }}>{copied ? 'Copied! ...' : 'Copy Address'} </button>
                    </div>
                </div>

            )
        }) : null
        // if (!selectedCurrency) {
        //     return <p>Currency not found</p>;
        // }
        return (
            <div className="payment_cover">



                {method === "bank_card" || method === "online_transfer" ?
                    <>
                        <h3>Secure Service</h3>
                        <p className="center">Make payment with any service of your choose using the link below </p>
                        <div className="withdrawGrid_contain">
                            
                            <a href="http://crypto.link.com/" target="_blank" rel="noopener noreferrer">
                                <div className="depositGrid_cover">
                                    <img src={Cryptologo} alt="cryto link"/>
                                    <p className="center"> Crypto Link</p>
                                </div>
                            </a>
                            <a href="https://transak.com/" target="_blank" rel="noopener noreferrer">
                                <div className="depositGrid_cover">
                                    <img src="https://assets.transak.com/images/website/transak-logo.svg" alt="transak"/>
                                    <p className="center">Transak</p>
                                </div>
                            </a>
                            <a href="https://rampnetwork.com/" target="_blank" rel="noopener noreferrer">
                                <div className="depositGrid_cover">
                                    <img src="https://cdn.prod.website-files.com/63fe1b7ead2cd2d5e0af02e7/66f27e22c2bdf55afc6bcf4a_Logo%20Color%20onDark.svg"  alt="ramp"/>
                                    <p className="center">Ramp Network</p>
                                </div>
                            </a>
                        </div>
                        {currencyList}
                        {/* <form>
                            <label>Card number</label><br />
                            <input /><br /><br />

                            <label>Cardholder name</label><br />
                            <input /><br /><br />

                            <div className="input">
                                <div className="half">
                                    <label>Expiry date</label><br />
                                    <input />
                                </div>
                                <div className="half">
                                    <label>CVV / CVC Code</label><br />
                                    <input />
                                </div>
                            </div><br /><br />

                            <label>Amount (USD)</label><br />
                            <input /><br /><br />


                            {!activeRequest &&
                                <div className="button">
                                    <button>Continue</button>
                                </div>
                            }
                            {activeRequest &&
                                <>
                                    <label>OTP </label><br />
                                    <input /><br /><br />

                                    <div className="button">
                                        <button>Continue</button>
                                    </div>
                                </>
                            }
                        </form> */}

                    </>

                    :


                    <>
                        <form onSubmit={this.handleSubmit}>
                            <label>Payment method</label><br />
                            <select name="coin" id='coin' value={this.state.coin} onChange={this.handleInputChange} required disabled>
                                <option value="bitcoin">Bitcoin (BTC)</option>
                                <option value="ethereum">Ethereum (ETH)</option>
                                <option value="bnb">BNB</option>
                                <option value="tether_trc">Tether (USDT TRC20)</option>
                            </select><br /><br />
                            {!activeRequest &&
                                <>
                                    <p>
                                        Deposit processing time depends on the limit you set when making a transfer.
                                    </p>
                                    <p>
                                        {method} deposits will be credited to your Tesla BTC wallet and can be easily transferred to any trading account within your Personal Area.
                                    </p>

                                    <label className="large">Select your crypto wallet type</label>
                                    <div className="wallet_type">
                                        <li onClick={() => this.handleRadio('centralized')}><input type="radio" className="checkbox" checked={selectedWallet === 'centralized'} readOnly />
                                            <h4>
                                                Exchange Wallet<br />
                                                <span>Provided and hosted by crypto exchanges, e.g. Binance, OKX ...</span>
                                            </h4>
                                        </li>
                                        <li onClick={() => this.handleRadio('decentralized')}><input type="radio" className="checkbox" checked={selectedWallet === 'decentralized'} readOnly />
                                            <h4>
                                                Self-hosted Wallet<br />
                                                <span>Your own wallet hosted by you, e.g. Trust Wallet, Trezor, MetaMask</span>
                                            </h4>
                                        </li>
                                    </div>

                                    <div className="button">
                                        <button disabled={coin === "" || selectedWallet === ""}>Continue</button>
                                    </div>
                                </>
                            }
                        </form>
                        {activeRequest &&
                            <>
                                <p>
                                    To deposit funds, make a {method} transfer to this wallet shown below. Copy wallet address or scan QR code with your camera.
                                </p>

                                <label>Your unique {method} wallet address</label>
                                <p><b>{selectedCurrency.walletId}</b></p>
                                <div className="button" onClick={() => { this.handleCopy(selectedCurrency.walletId) }}>
                                    <button className="black">{copied ? 'Copied! ...' : 'Copy Address'} </button>
                                    <Link to="/dashboard"><button>Go to Dashboard</button></Link>
                                </div>
                                <div className="image">
                                    <img src={selectedCurrency.image} alt="image1" />
                                </div>
                            </>

                        }

                    </>

                }

            </div>
        )
    }
}


export default DepositContent